export function useTriid() {
  const generateTriid = async () => {
    try {
      // Utiliser le bon chemin pour le build Vite (prod et dev)
      const response = await fetch('/vocabulaire.txt');
      const text = await response.text();
      const words = text.split('\n').filter(word => word.trim() !== '');
      const selectedWords = getRandomWords(words, 3);
      return selectedWords.join(', ');
    } catch (error) {
      console.error("Erreur lors de la génération du tri-identifiant :", error);
      return "";
    }
  };

  const getRandomWords = (words: string[], count: number) => {
    const shuffled = words.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  };

  return {
    generateTriid
  };
} 